module.exports = __webpack_public_path__ + "static/media/raiff-screen04.6516e675.png";